"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClient = void 0;
var bluebird_1 = __importDefault(require("bluebird"));
var http_errors_1 = __importDefault(require("http-errors"));
var headers_1 = require("./headers");
var httpConstants_1 = require("./httpConstants");
var HttpResult_1 = require("./HttpResult");
/**
 * HttpClient provides some convenience methods for interacting with our API.
 * Results are returned in a HttpResult object that provides information about
 * the original request and some metrics for analytics. All results are returned
 * as bluebird Promises.
 */
var HttpClient = /** @class */ (function () {
    function HttpClient() {
    }
    // retrieves the file at the given URL and returns it as a IFileBlob
    HttpClient.downloadFile = function (url) {
        var _this = this;
        return new bluebird_1.default(function (resolve, reject) {
            var result = new HttpResult_1.HttpResult(httpConstants_1.HttpMethod.Get, url);
            fetch(url, { headers: _this.buildRequestHeaders(false) })
                .then(function (response) {
                if (!response.ok) {
                    throw http_errors_1.default(response.status, 'Failed to download file.');
                }
                var filename = _this.extractFileName(response.headers.get(headers_1.HttpHeader.ContentDisposition));
                result.applyData({
                    filename: filename,
                    blob: response.blob()
                });
                resolve(result);
            })
                .catch(reject);
        });
    };
    HttpClient.get = function (url) {
        return this.sendRequest(url, httpConstants_1.HttpMethod.Get, 'Failed to retrieve JSON data');
    };
    HttpClient.patch = function (url, payload) {
        return this.sendUpdateRequest(url, httpConstants_1.HttpMethod.Patch, payload);
    };
    HttpClient.post = function (url, payload) {
        return this.sendUpdateRequest(url, httpConstants_1.HttpMethod.Post, payload);
    };
    HttpClient.put = function (url, payload) {
        return this.sendUpdateRequest(url, httpConstants_1.HttpMethod.Put, payload);
    };
    HttpClient.delete = function (url) {
        return this.sendRequest(url, httpConstants_1.HttpMethod.Delete, 'Failed to delete item.');
    };
    /**
     * Safely cancels an HTTP request that was made.
     *
     * @param requestPromise - Promise returned from get, patch, post or put.
     * @returns - undefined which is the recommended value to store in place of the cancelled or completed request.
     */
    HttpClient.safeCancelRequest = function (requestPromise) {
        if (requestPromise && requestPromise.isPending()) {
            requestPromise.cancel();
        }
        return undefined;
    };
    /**
     * Extracts the file name from the content disposition header.
     */
    HttpClient.extractFileName = function (disposition) {
        var result;
        if (disposition && disposition.indexOf('attachment') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                result = matches[1].replace(/['"]/g, '');
            }
        }
        return result;
    };
    HttpClient.sendUpdateRequest = function (url, method, payload) {
        return this.sendRequest(url, method, 'Failed to send JSON data.', payload);
    };
    HttpClient.sendRequest = function (url, method, errorMessage, payload) {
        var _this = this;
        return new bluebird_1.default(function (resolve, reject) {
            var result = new HttpResult_1.HttpResult(method, url);
            fetch(url, {
                method: method,
                headers: _this.buildRequestHeaders(true),
                body: payload ? JSON.stringify(payload) : undefined
            })
                .then(HttpClient.parseResponse(errorMessage))
                .then(function (data) {
                result.applyData(data);
                resolve(result);
            })
                .catch(reject);
        });
    };
    /**
     * Create a HTTP request header for API calls
     */
    HttpClient.buildRequestHeaders = function (forJsonSend) {
        var requestHeaders = new Headers();
        if (forJsonSend) {
            requestHeaders.append(headers_1.HttpHeader.ContentType, 'application/json');
        }
        return requestHeaders;
    };
    /**
     * Common routine for parsing a API response
     */
    HttpClient.parseResponse = function (message) {
        return function (response) {
            return new bluebird_1.default(function (resolve, reject) {
                try {
                    if (!response.ok) {
                        reject(http_errors_1.default(response.status, message));
                    }
                    else {
                        resolve(response.json());
                    }
                }
                catch (err) {
                    reject(err);
                }
            });
        };
    };
    return HttpClient;
}());
exports.HttpClient = HttpClient;
